import { Resource } from 'solid-js';
import { MultiSearchResultType } from '../../containers/product-category/product-category-container';
import {
    getProductStatus,
    getStatusRelatedElements,
} from '../regcheck-search-results/regcheck-search-results-item/regcheck-search-results-item';
import { Product } from './product-categories.d';
import { colors } from '../../style/style-variables';
import { StyledInnerLinkTag, StyledLinkTag, StyledLink } from './product-link.styles';
import { OriginProduct } from '../../containers/regcheck/regcheck-container';

type Props = {
    product: Product;
    regNos: Resource<MultiSearchResultType[]>;
    originProducts: Resource<{ originProducts: OriginProduct[] }>;
};

export function getRegNoStatusForProduct(
    productName: string = '',
    multiSearchResults: MultiSearchResultType[] = [],
    originProducts: OriginProduct[] = []
) {
    if (!productName) {
        return null;
    }

    const results = multiSearchResults || [];
    const originProduct = originProducts.find((product) => product.name.toLocaleLowerCase() === productName.toLocaleLowerCase());

    const regNos = Array.isArray(results)
        ? results.filter((regNo) => {
            // OK - special case
            if (originProduct) {
                const parentProduct = results.find((regNo) => regNo.regNumber === originProduct.originProductRegistrationNumber);
                if (!parentProduct) {
                    return false;
                }

                return regNo.productName === parentProduct.productName;
            }

            return regNo.productName === productName;
        })
        : [];

    if (!regNos.length) {
        return null;
    }

    const s = regNos.map((regNo) => {
        const status = getProductStatus(regNo);
        return {
            ...regNo,
            ...getStatusRelatedElements(status),
        };
    });

    // First, look for any approved registration numbers
    const activeRegNo = s.find((regNo) => regNo.status === 'approved');
    if (activeRegNo) {
        return activeRegNo;
    }

    // Then check for any outgoing registration numbers
    const outgoingRegNo = s.find((regNo) => regNo.status === 'outgoing');
    if (outgoingRegNo) {
        return outgoingRegNo;
    }

    // Finally, check for any expired registration numbers
    const expiredRegNo = s.find((regNo) => regNo.status === 'expired');
    if (expiredRegNo) {
        return expiredRegNo;
    }

    return null;
}

export const ProductLink = (props: Props) => (
    <StyledLink>
        <StyledLinkTag href={`/kategorier/produkter/${props.product.slug}`}>
            <StyledInnerLinkTag>
                {(() => {
                    const status = getRegNoStatusForProduct(
                        props.product.name,
                        props.regNos(),
                        props.originProducts()?.originProducts || []
                    );
                    return status?.Icon ? <status.Icon /> : '';
                })()}
                <div>{props.product.name}</div>
            </StyledInnerLinkTag>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <path fill="none" d="M0 0h24v24H0z" />
                <path fill={colors.red} d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z" />
            </svg>{' '}
        </StyledLinkTag>
    </StyledLink>
);
